export default {
  currentApplication: null,
  currentReport: null,
}
